import React, { Suspense, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";

import { isLogin } from "../utils/userLoggedInCheck";
import Loader from "../library/Loader";
import useQuery from "../utils/_hooks/useQuery";
import { setMobileAuthCookies } from "../utils/utilityFunctions";
import { aesDecryption } from "../networking/security";
import useOnboardingChecks from "../utils/_hooks/useOnboardingChecks";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const token = useQuery().get("token");
    const { refreshTokenFn } = useOnboardingChecks();

    useEffect(() => {
        if (!token) return;

        const authObj =
            JSON.parse(aesDecryption(decodeURIComponent(token), "ONBOARD_MOBILE") || null) || {};
        setMobileAuthCookies(authObj);
        refreshTokenFn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <Route
            {...rest}
            render={(props) =>
                isLogin() || token ? (
                    <Suspense fallback={<Loader />}>
                        <Component {...props} {...rest} />
                    </Suspense>
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
